/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { Ptw100InternalServerException } from './Ptw100InternalServerException';
import {
    Ptw100InternalServerExceptionFromJSON,
    Ptw100InternalServerExceptionFromJSONTyped,
    Ptw100InternalServerExceptionToJSON,
} from './Ptw100InternalServerException';

/**
 * 
 * @export
 * @interface ErrorResponseOfPtw100InternalServerException
 */
export interface ErrorResponseOfPtw100InternalServerException {
    /**
     * 
     * @type {number}
     * @memberof ErrorResponseOfPtw100InternalServerException
     */
    readonly httpStatusCode?: number;
    /**
     * 
     * @type {Ptw100InternalServerException}
     * @memberof ErrorResponseOfPtw100InternalServerException
     */
    exception: Ptw100InternalServerException;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponseOfPtw100InternalServerException
     */
    $type?: ErrorResponseOfPtw100InternalServerExceptionTypeEnum;
}


/**
 * @export
 */
export const ErrorResponseOfPtw100InternalServerExceptionTypeEnum = {
    PtwPtw100WebSharedModelsErrorResponseErrorResponse1PtwPtw100AppZeroCoreSharedExceptionsPtw100InternalServerExceptionPtwPtw100AppZeroCoreSharedPtwPtw100WebShared: 'Ptw.Ptw100.Web.Shared.Models.ErrorResponse.ErrorResponse`1[[Ptw.Ptw100.AppZero.Core.Shared.Exceptions.Ptw100InternalServerException, Ptw.Ptw100.AppZero.Core.Shared]], Ptw.Ptw100.Web.Shared'
} as const;
export type ErrorResponseOfPtw100InternalServerExceptionTypeEnum = typeof ErrorResponseOfPtw100InternalServerExceptionTypeEnum[keyof typeof ErrorResponseOfPtw100InternalServerExceptionTypeEnum];



/**
 * Check if a given object implements the ErrorResponseOfPtw100InternalServerException interface.
 */
export function instanceOfErrorResponseOfPtw100InternalServerException(value?: unknown): value is ErrorResponseOfPtw100InternalServerException {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ErrorResponseOfPtw100InternalServerExceptionTypeEnum)[0];
}

export function ErrorResponseOfPtw100InternalServerExceptionFromJSON(json: any): ErrorResponseOfPtw100InternalServerException {
    return ErrorResponseOfPtw100InternalServerExceptionFromJSONTyped(json, false);
}

export function ErrorResponseOfPtw100InternalServerExceptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ErrorResponseOfPtw100InternalServerException {
    if (json == null) {
        return json;
    }
    return {
        
        'httpStatusCode': json['httpStatusCode'] == null ? undefined : json['httpStatusCode'],
        'exception': Ptw100InternalServerExceptionFromJSON(json['exception']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function ErrorResponseOfPtw100InternalServerExceptionToJSON(value?: Omit<ErrorResponseOfPtw100InternalServerException, 'httpStatusCode'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'exception': Ptw100InternalServerExceptionToJSON(value['exception']),
        '$type': value['$type'],
    });
}

